import 'isomorphic-fetch';
class ApiError {
    message;
    details = null;
    constructor(message) {
        this.message = message;
    }
}
class SportnetApi {
    baseUrl = 'https://api.sportnet.online/v1';
    token = '';
    serializeQueryParams(parameters) {
        return Object.keys(parameters)
            .reduce((acc, p) => {
            const param = parameters[p];
            if (typeof param === 'undefined' || param === '') {
                return acc;
            }
            return [
                ...acc,
                `${encodeURIComponent(p)}=${encodeURIComponent(String(parameters[p]))}`,
            ];
        }, [])
            .join('&');
    }
    transformParameter(value, transformOperation) {
        switch (transformOperation) {
            case 'joinUsingPipes':
                return Array.isArray(value) ? value.join('|') : value;
            default:
                return value;
        }
    }
    setBaseUrl(baseUrl) {
        this.baseUrl = baseUrl;
    }
    setToken(token) {
        this.token = token;
    }
    appendAuthHeaders(headerParams) {
        const headers = new Headers(headerParams);
        if (this.token) {
            headers.append('Authorization', `Bearer ${this.token}`);
        }
        return headers;
    }
    async request(method, url, body, headers = new Headers(), queryParameters = {}) {
        const queryParams = queryParameters && Object.keys(queryParameters).length
            ? this.serializeQueryParams(queryParameters)
            : null;
        const urlWithParams = url + (queryParams ? '?' + queryParams : '');
        if (headers.get('Content-Type') === 'multipart/form-data') {
            const form = new FormData();
            for (let k in body) {
                form.append(k, body[k]);
            }
            body = form;
        }
        else if (headers.get('Content-Type') === 'application/json' &&
            body &&
            Object.keys(body).length > 0) {
            body = JSON.stringify(body);
        }
        else {
            body = undefined;
        }
        if (headers.get('Content-Type') === 'multipart/form-data') {
            headers.delete('Content-Type');
        }
        const response = await fetch(urlWithParams, { method, headers, body });
        if (response.ok) {
            return response.json();
        }
        else {
            const err = new ApiError(response.statusText);
            err.details = await response.json();
            throw err;
        }
    }
    listCodelists(parameters = {}) {
        let path = '/codelist';
        let headers = new Headers();
        let queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    getCodelist(codelist, parameters = {}) {
        let path = '/codelist/{codelist}';
        let headers = new Headers();
        let queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{codelist}', codelist.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    getCodelistSector(codelist, codelistItem, parameters = {}) {
        let path = '/codelist/{codelist}/{codelistItem}/sector';
        let headers = new Headers();
        let queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{codelist}', codelist.toString());
        path = path.replace('{codelistItem}', codelistItem.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    getCodelistSectorDiscipline(codelist, codelistItem, sectorItem, parameters = {}) {
        let path = '/codelist/{codelist}/{codelistItem}/sector/{sectorItem}/discipline';
        let headers = new Headers();
        let queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{codelist}', codelist.toString());
        path = path.replace('{codelistItem}', codelistItem.toString());
        path = path.replace('{sectorItem}', sectorItem.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    getPublicApps(parameters = {}) {
        let path = '/apps';
        let headers = new Headers();
        let queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    getPublicApp(appId, parameters = {}) {
        let path = '/apps/{appId}';
        let headers = new Headers();
        let queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appId}', appId.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    me(parameters = {}) {
        let path = '/me';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meInvitations(parameters = {}) {
        let path = '/me/invitations';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        queryParameters['offset'] = 0;
        if (typeof parameters['offset'] !== 'undefined') {
            queryParameters['offset'] = parameters['offset'];
        }
        queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
        queryParameters['limit'] = 100;
        if (typeof parameters['limit'] !== 'undefined') {
            queryParameters['limit'] = parameters['limit'];
        }
        queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meRelations(parameters = {}) {
        let path = '/me/relations';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meRelationTakeover(relatedId, parameters = {}) {
        let path = '/me/relations/{relatedId}/takeover';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{relatedId}', relatedId.toString());
        return this.request('POST', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meMessages(parameters = {}) {
        let path = '/me/messages';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        queryParameters['offset'] = 0;
        if (typeof parameters['offset'] !== 'undefined') {
            queryParameters['offset'] = parameters['offset'];
        }
        queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
        queryParameters['limit'] = 100;
        if (typeof parameters['limit'] !== 'undefined') {
            queryParameters['limit'] = parameters['limit'];
        }
        queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
        if (typeof parameters['q'] !== 'undefined') {
            queryParameters['q'] = parameters['q'];
        }
        queryParameters['q'] = this.transformParameter(queryParameters['q']);
        if (typeof parameters['read'] !== 'undefined') {
            queryParameters['read'] = parameters['read'];
        }
        queryParameters['read'] = this.transformParameter(queryParameters['read']);
        if (typeof parameters['important'] !== 'undefined') {
            queryParameters['important'] = parameters['important'];
        }
        queryParameters['important'] = this.transformParameter(queryParameters['important']);
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meUnreadMessagesCount(parameters = {}) {
        let path = '/me/messages-unread-count';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meMessageById(courierMessageIds, parameters = {}) {
        let path = '/me/messages/{courierMessageIds}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{courierMessageIds}', courierMessageIds.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meMessageStatusChange(courierMessageIds, parameters = {}, body) {
        let path = '/me/messages/{courierMessageIds}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{courierMessageIds}', courierMessageIds.toString());
        return this.request('PUT', `${this.baseUrl}${path}`, body, headers, queryParameters);
    }
    meUserGroups(parameters = {}) {
        let path = '/me/groups';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meRequests(parameters = {}) {
        let path = '/me/requests';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meInvoices(parameters = {}) {
        let path = '/me/invoices';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meInvoicePdf(invoiceId, parameters = {}) {
        let path = '/me/invoices/{invoiceId}/pdf';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{invoiceId}', invoiceId.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meAwards(parameters = {}) {
        let path = '/me/awards';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meAwardsGet(itemId, parameters = {}) {
        let path = '/me/awards/{itemId}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{itemId}', itemId.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meAffilationProlong(parameters, body) {
        let path = '/me/affilations';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('PUT', `${this.baseUrl}${path}`, body, headers, queryParameters);
    }
    meAffilationPaygate(orderId, parameters) {
        let path = '/me/affilations/orders/{orderId}/payment';
        let headers = new Headers();
        let queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Accept', 'text/plain');
        headers.append('Accept', 'text/html');
        headers.append('Content-Type', 'application/json');
        if (typeof parameters['callbackUrl'] !== 'undefined') {
            queryParameters['callbackUrl'] = parameters['callbackUrl'];
        }
        queryParameters['callbackUrl'] = this.transformParameter(queryParameters['callbackUrl']);
        if (typeof parameters['callbackUrl'] === 'undefined') {
            throw new Error('Missing required parameter: callbackUrl');
        }
        queryParameters['redirect'] = false;
        if (typeof parameters['redirect'] !== 'undefined') {
            queryParameters['redirect'] = parameters['redirect'];
        }
        queryParameters['redirect'] = this.transformParameter(queryParameters['redirect']);
        queryParameters['test'] = false;
        if (typeof parameters['test'] !== 'undefined') {
            queryParameters['test'] = parameters['test'];
        }
        queryParameters['test'] = this.transformParameter(queryParameters['test']);
        path = path.replace('{orderId}', orderId.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meAffilationPaymentResult(orderId, parameters = {}) {
        let path = '/me/affilations/orders/{orderId}/payment/result';
        let headers = new Headers();
        let queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        queryParameters['test'] = false;
        if (typeof parameters['test'] !== 'undefined') {
            queryParameters['test'] = parameters['test'];
        }
        queryParameters['test'] = this.transformParameter(queryParameters['test']);
        path = path.replace('{orderId}', orderId.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meMembership(parameters = {}) {
        let path = '/me/membership';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meMembershipGet(itemId, parameters = {}) {
        let path = '/me/membership/{itemId}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{itemId}', itemId.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meRegnrs(parameters = {}) {
        let path = '/me/regnrs';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meProfiles(parameters = {}) {
        let path = '/me/profiles';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meProfilesIssf(parameters = {}) {
        let path = '/me/profiles/issf';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meProfilesIssfConnect(parameters) {
        let path = '/me/profiles/issf/connect';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        if (typeof parameters['code'] !== 'undefined') {
            queryParameters['code'] = parameters['code'];
        }
        queryParameters['code'] = this.transformParameter(queryParameters['code']);
        if (typeof parameters['code'] === 'undefined') {
            throw new Error('Missing required parameter: code');
        }
        if (typeof parameters['redirectUri'] !== 'undefined') {
            queryParameters['redirect_uri'] = parameters['redirectUri'];
        }
        queryParameters['redirect_uri'] = this.transformParameter(queryParameters['redirect_uri']);
        if (typeof parameters['redirectUri'] === 'undefined') {
            throw new Error('Missing required parameter: redirectUri');
        }
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meProfilesIssfToken(parameters = {}) {
        let path = '/me/profiles/issf/token';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meProfilesFacebook(parameters = {}) {
        let path = '/me/profiles/facebook';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meProfilesFacebookToken(parameters = {}) {
        let path = '/me/profiles/facebook/token';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meProfile(parameters = {}) {
        let path = '/me/profile';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meProfileUpdate(parameters, body) {
        let path = '/me/profile';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('PUT', `${this.baseUrl}${path}`, body, headers, queryParameters);
    }
    meAddresses(parameters = {}) {
        let path = '/me/addresses';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        if (typeof parameters['type'] !== 'undefined') {
            queryParameters['type'] = parameters['type'];
        }
        queryParameters['type'] = this.transformParameter(queryParameters['type']);
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meAddressesCreate(parameters, body) {
        let path = '/me/addresses';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('POST', `${this.baseUrl}${path}`, body, headers, queryParameters);
    }
    meAddressesGet(itemId, parameters = {}) {
        let path = '/me/addresses/{itemId}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{itemId}', itemId.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meAddressesUpdate(itemId, parameters, body) {
        let path = '/me/addresses/{itemId}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{itemId}', itemId.toString());
        return this.request('PUT', `${this.baseUrl}${path}`, body, headers, queryParameters);
    }
    meAddressesDelete(itemId, parameters = {}) {
        let path = '/me/addresses/{itemId}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{itemId}', itemId.toString());
        return this.request('DELETE', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meBankAccounts(parameters = {}) {
        let path = '/me/bank-accounts';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meBankAccountsCreate(parameters, body) {
        let path = '/me/bank-accounts';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('POST', `${this.baseUrl}${path}`, body, headers, queryParameters);
    }
    meBankAccountsGet(itemId, parameters = {}) {
        let path = '/me/bank-accounts/{itemId}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{itemId}', itemId.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meBankAccountsUpdate(itemId, parameters, body) {
        let path = '/me/bank-accounts/{itemId}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{itemId}', itemId.toString());
        return this.request('PUT', `${this.baseUrl}${path}`, body, headers, queryParameters);
    }
    meBankAccountsDelete(itemId, parameters = {}) {
        let path = '/me/bank-accounts/{itemId}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{itemId}', itemId.toString());
        return this.request('DELETE', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meCustomFields(parameters = {}) {
        let path = '/me/custom';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meCustomFieldsCreate(parameters, body) {
        let path = '/me/custom';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('POST', `${this.baseUrl}${path}`, body, headers, queryParameters);
    }
    meCustomFieldsGet(itemId, parameters = {}) {
        let path = '/me/custom/{itemId}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{itemId}', itemId.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meCustomFieldsUpdate(itemId, parameters, body) {
        let path = '/me/custom/{itemId}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{itemId}', itemId.toString());
        return this.request('PUT', `${this.baseUrl}${path}`, body, headers, queryParameters);
    }
    meCustomFieldsDelete(itemId, parameters = {}) {
        let path = '/me/custom/{itemId}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{itemId}', itemId.toString());
        return this.request('DELETE', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meSportOrgs(parameters = {}) {
        let path = '/me/sport-orgs';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meSportExpertOrgs(parameters = {}) {
        let path = '/me/sport-expert-orgs';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meLicenses(parameters = {}) {
        let path = '/me/licenses';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meLicensesCreate(parameters, body) {
        let path = '/me/licenses';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('POST', `${this.baseUrl}${path}`, body, headers, queryParameters);
    }
    meAppSpaces(parameters = {}) {
        let path = '/me/appspaces';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        queryParameters['expandApp'] = false;
        if (typeof parameters['expandApp'] !== 'undefined') {
            queryParameters['expandApp'] = parameters['expandApp'];
        }
        queryParameters['expandApp'] = this.transformParameter(queryParameters['expandApp']);
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meAppSpacesForApp(appId, parameters = {}) {
        let path = '/me/appspaces/{appId}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appId}', appId.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meAppInfoForAppSpace(appId, appSpace, parameters = {}) {
        let path = '/me/appspaces/{appId}/appspace/{appSpace}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appId}', appId.toString());
        path = path.replace('{appSpace}', appSpace.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    meAccessTokens(parameters = {}) {
        let path = '/me/access-tokens';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    mePasswd(parameters = {}, body) {
        let path = '/me/passwd';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('POST', `${this.baseUrl}${path}`, body, headers, queryParameters);
    }
    mePhotoUpload(parameters, form) {
        let path = '/me/photo';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'multipart/form-data');
        return this.request('POST', `${this.baseUrl}${path}`, form, headers, queryParameters);
    }
    mePhotoDelete(parameters = {}) {
        let path = '/me/photo';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('DELETE', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    oauthRevokeToken(parameters = {}, body) {
        let path = '/oauth/revoke';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return this.request('POST', `${this.baseUrl}${path}`, body, headers, queryParameters);
    }
    organizationPPOProfiles(parameters = {}) {
        const path = '/ppo';
        const headers = new Headers();
        const queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        if (typeof parameters['ids'] !== 'undefined') {
            queryParameters['ids'] = parameters['ids'];
        }
        queryParameters['ids'] = this.transformParameter(queryParameters['ids']);
        if (typeof parameters['sectors'] !== 'undefined') {
            queryParameters['sectors'] = parameters['sectors'];
        }
        queryParameters['sectors'] = this.transformParameter(queryParameters['sectors']);
        if (typeof parameters['type'] !== 'undefined') {
            queryParameters['type'] = parameters['type'];
        }
        queryParameters['type'] = this.transformParameter(queryParameters['type']);
        if (typeof parameters['q'] !== 'undefined') {
            queryParameters['q'] = parameters['q'];
        }
        queryParameters['q'] = this.transformParameter(queryParameters['q']);
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
}
export default new SportnetApi();
